import { useState, useEffect } from 'react'
import s from '../Notes.scss'
import { FaChevronDown, FaChevronUp, FaPen, FaTrashAlt } from 'react-icons/fa'
import cn from 'classnames'
import { timezoneDate } from 'utils/helpers'
import { isAdmin } from 'utils/authService'
import { getBaseUrl } from 'utils/api'

const Note = ({ note, toggleAddNoteModal, hideCompay, hideContact, allCollapsed, deleteNote }) => {
  const [collapsed, setCollapsed] = useState(false)

  const toggleCollapsed = () => {
    setCollapsed(!collapsed)
  }

  useEffect(() => {
    setCollapsed(allCollapsed)
  }, [allCollapsed])

  return (
    <tr className={s.row} style={{ height: '100%' }}>
      <td>{timezoneDate(note.updatedAt, 'hh:mm A')}</td>
      <td>
        {note.updatedBy
          ? (note.updatedBy?.firstName ?? '') + ' ' + (note.updatedBy?.lastName ?? '')
          : (note.createdBy?.firstName ?? '') + ' ' + (note.createdBy?.lastName ?? '')}
      </td>
      {!hideContact && (
        <td>
          {note.contact ? note.contact.firstName + ' ' + note.contact.lastName : '-'}
          {note.contact && (
            <>
              <div
                title={note.contact.firstName + ' ' + note.contact.lastName}
                key={note.contact.id}
                className={cn(s.user, s.pullRight)}
                style={{ backgroundImage: `url(${note.contact.photo})` }}
              />
              {!hideCompay && <p>{note.contact.company.name}</p>}
            </>
          )}
        </td>
      )}
      <td>
        {note.attachments.length > 0 ? (
          <div
            className={cn(s.attachments, {
              [s.collapsed]: collapsed
            })}
          >
            {note.attachments.map(attachment => (
              <p key={attachment.s3Key} className={s.file}>
                {attachment.originalFileName ? (
                  <a
                    href={`${getBaseUrl('/v1/test/get-s3-object')}/${attachment.s3Key}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {attachment.originalFileName}
                  </a>
                ) : (
                  <span className={s.file}>{attachment.name}</span>
                )}
              </p>
            ))}
          </div>
        ) : (
          '-'
        )}
      </td>
      <td className={cn(s.widthNote, s.relative)} style={{ height: '100%' }}>
        <div
          className={cn(s.note, {
            [s.collapsed]: collapsed
          })}
          dangerouslySetInnerHTML={{ __html: note.note }}
        />
        <div className={s.footer}>
          <span>Created on: {timezoneDate(note.dateEntered, 'hh:mm A')}</span> -{' '}
          <span>
            Created by: {(note.createdBy?.firstName ?? '') + ' ' + (note.createdBy?.lastName ?? '')}
          </span>{' '}
          -{' '}
          <span className={s.edit} onClick={() => toggleAddNoteModal(note)}>
            <FaPen /> Edit
          </span>
          {isAdmin() && (
            <span style={{ marginLeft: 10 }} className={s.edit} onClick={() => deleteNote(note.id)}>
              <FaTrashAlt /> Delete
            </span>
          )}
        </div>
        {collapsed ? (
          <FaChevronUp onClick={() => toggleCollapsed()} className={s.toggleCollapsed} />
        ) : (
          <FaChevronDown onClick={() => toggleCollapsed()} className={s.toggleCollapsed} />
        )}
      </td>
    </tr>
  )
}

export default Note
